import { URLQueries } from './url_query'
import { pretreatEnv } from '../biz/pay/utils'
import { EnumPartitionID } from '../defines/enums'

/**
 * 根据xenv获取参数的 partition_id, 适用于xenv只投放固定一个partition的场景
 * @param {Object} params 参数，当传递了params, 会向params中增加partition_id 属性
 * @returns
 */
export const getParamsPartitionIdByXenv = params => {
  const DistingParitionMap = {
    esapp: EnumPartitionID.CompanyQuartz, // 企业版
    dymp: EnumPartitionID.DY, // 抖音
  }
  // TODO pretreatEnv 使用trade-sdk 中的
  const partition_id = DistingParitionMap[pretreatEnv()] || undefined
  if (params && partition_id) {
    params.partition_id = partition_id
  }
  return partition_id
}

export const getPartitionId = goods => {
  return (
    goods?.partition_id ||
    URLQueries.getQuery('partition_id') - 0 ||
    getParamsPartitionIdByXenv()
  )
}
